import { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { yupResolver } from '@hookform/resolvers/yup';
import { /* TOBEDELETED20240306 MEDSTAR_ASSOCIATION_TYPE__CONTRACTOR, */ MEDSTAR_ASSOCIATION_TYPE__PRE_ASSOCIATE, MEDSTAR_ASSOCIATION_TYPE__UNKNOWN } from "../../../sitel/commons/utilities/medstarAssociationType";
import HeaderSection from "../../new/step5Profile/headerSection";
import BasicFormSection from "../../../pageComponents/profilePages/basicFormSection";
import EmploymentInformationSection from "../../new/step5Profile/employmentInformationSection";

import schema from "../../../pageComponents/profilePages/formSchema";
import useFormSubmit from "../../../pageComponents/profilePages/useFormSubmit";
import { TitleWMutedRow } from "../../../sitel/demon/ui/atoms";
import SubmitButton from "../../../sitel/demon/ui/atoms/buttons/SubmitButton";
import ProfileFormModal from "../../../pageComponents/profilePages/profileFormModal";
import { titleText } from "../../../components/utils/medstarAssociationTexts";

export default function Profile({ userProfile,medstarAssociationType }) {
	console.log('M association type,',medstarAssociationType);
	const [submitStatus, setSubmitStatus] = useState('idle');
	const [showProfileModal, setShowProfileModal] = useState({ showModal: false, success: false,isNewAccount:false })
	const formSchema = schema(medstarAssociationType);
	console.log('FORM SCHEMA',formSchema);
	const { register, handleSubmit, formState: { errors, isSubmitting, isSubmitSuccessful } } = useForm({ resolver: yupResolver(formSchema), defaultValues: { ...userProfile.editable_fields, ...userProfile.readonly_fields } });
	const onSubmit = useFormSubmit(medstarAssociationType, setSubmitStatus, showProfileModal, setShowProfileModal, 'update');
	const language = titleText(medstarAssociationType);
	
	// TODO - Not sure where to place this function within our current folder set up. 
	// Define the function to disable input elements
	// Call the function once the form has been mounted
	useEffect(() => {
		if (userProfile) {
			Object.keys(userProfile.readonly_fields).forEach((field) => {
				const inputElement = document.getElementById(field);
				if (inputElement) {
					inputElement.disabled = true;
				}
			});
		}
	}, [userProfile]);

	const needHeader = () => {
		// we need to show header ONLY if the medstar_association_type is still UNKNOWN or PRE_ASSOCIATE
		// TODO document why this decision is including pre associate
		return (medstarAssociationType === MEDSTAR_ASSOCIATION_TYPE__PRE_ASSOCIATE || 
			    medstarAssociationType === MEDSTAR_ASSOCIATION_TYPE__UNKNOWN);
	}

	const needBody = () => {
		// We need to show body section when the medstar_association_type is defines( NOT UNKNOWN). 
		// That means if user's medstar_association_type is still UNKNOWN, do not show body until he selects the proper type(student, contractor, board member,..)
		return (medstarAssociationType !== MEDSTAR_ASSOCIATION_TYPE__UNKNOWN);

	}

	return (
		<>
			<TitleWMutedRow muted={language.mutedTitle}>{language.title}</TitleWMutedRow>
			<form onSubmit={handleSubmit(onSubmit)}>
				{
					needHeader()
						? <HeaderSection medstarAssociationType={medstarAssociationType} register={register} errors={errors} />
						: <TitleWMutedRow muted="some fields have been  disabled"><hr />Please ensure that your profile is up to date.</TitleWMutedRow>
				}
				{(needBody())
					?
					<>
						<BasicFormSection register={register} errors={errors} />
						<EmploymentInformationSection medstarAssociationType={medstarAssociationType} register={register} errors={errors} />
						<div className="row justify-content-end">
							<div className="col-auto my-1">
								<SubmitButton isSubmitting={isSubmitting} isSubmitSuccessful={isSubmitSuccessful && (!(submitStatus === 'profile-save-failed') && !(submitStatus === 'profile-saved'))} defaultLabel='Update My Account' className="btn-medstar-primary" />
							</div>
						</div>
					</>
					: null

				}
			</form>
			<ProfileFormModal showProfileModal={showProfileModal} setShowProfileModal={setShowProfileModal} />
		</>
	);
}
